import { useMutation } from '@tanstack/react-query';
import axiosInstance from 'ns_libs/nsAxios';
import API_ENDPOINTS from 'services/urls';
import { TimelineItem } from 'views/DealDashboard/Overview/Timeline/types';

type DuplicateTimelineVariables = {
    orgId: string;
    dealId: number;
    timelineId: string;
};

export const duplicateTimeline = async ({
    orgId, dealId, timelineId,
}: DuplicateTimelineVariables): Promise<TimelineItem> => {
    const response = await axiosInstance.post(API_ENDPOINTS.TIMELINE_DUPLICATE(orgId, dealId, timelineId));
    return response.data;
};

export const useDuplicateTimeline = () => useMutation({
    mutationFn: duplicateTimeline,
});
